import { Sparkles, Zap, Headphones, ShieldCheck } from 'lucide-react';

const highlights = [
  { icon: Sparkles, title: 'Zyra AI Copilot', text: 'Drafts replies and summarizes threads instantly.' },
  { icon: Zap, title: 'Instant Answers', text: 'Deflect FAQs using your knowledge base.' },
  { icon: Headphones, title: 'Agent Coaching', text: 'Real-time suggestions for faster replies.' },
  { icon: ShieldCheck, title: 'Safe by Design', text: 'Escalation rules keep sensitive data protected.' },
];

export default function AiFirst() {
  return (
    <section className="bg-slate-950 py-24 text-white" aria-labelledby="ai-first-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-2">
          <div>
            <h2 id="ai-first-heading" className="text-3xl font-extrabold tracking-tight sm:text-4xl">
              Designed for <span className="gradient-text">AI-first</span> customer service
            </h2>
            <p className="mt-4 text-lg text-slate-400">
              Zyra understands context, drafts replies, and coaches your team in real time.
            </p>
            <ul className="mt-8 grid gap-4 sm:grid-cols-2">
              {highlights.map((h) => (
                <li key={h.title} className="flex items-start gap-3">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl bg-brand-600/20 text-brand-400">
                    <h.icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white">{h.title}</h3>
                    <p className="text-sm text-slate-400">{h.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="relative">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-brand-600/30 to-indigo-500/20 blur-2xl" />
            <div className="relative overflow-hidden rounded-3xl border border-slate-800 bg-slate-900/80 p-2 shadow-2xl backdrop-blur">
              <img
                src="https://media.getzurihub.com/Jayrah%20Assets/Reduce_Wait_Times__en_us.avif"
                alt="Zyra AI reducing wait times for customer service"
                className="rounded-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
